/**
 * Smooth scroll composable for navigation
 * Provides smooth scrolling to sections and active section detection
 */
export function useSmoothScroll() {
  const scrollToSection = (sectionId) => {
    const element = document.querySelector(sectionId);

    if (element) {
      const offsetY = 80; // Account for fixed navbar height
      const targetY = element.offsetTop - offsetY;

      window.scrollTo({
        top: targetY,
        behavior: 'smooth'
      });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const getActiveSection = (sections) => {
    const scrollPosition = window.scrollY + 100; // Offset for navbar

    for (let i = sections.length - 1; i >= 0; i--) {
      const section = document.querySelector(sections[i]);
      if (section && section.offsetTop <= scrollPosition) {
        return sections[i];
      }
    }

    return sections[0];
  };

  return {
    scrollToSection,
    scrollToTop,
    getActiveSection
  };
}
